<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/marca"> Cadastro/Produtos e Serviços/Marcas </router-link>
      <label class="labelBar"> / </label>
      <label v-if="!readOnly"> Editar</label>
      <label v-else> Ver</label>
    </div>
    <tab-navegacao-produto />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col>
            <v-text-field
              label="Marca *"
              v-model="descricao"
              v-uppercase
              :counter="200"
              :readonly="readOnly"
              :rules="[(v) => !!v || 'A Descrição é obrigatória']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="marca.ativo"
            @click.native.stop.prevent="checkAssociacao()"
            label="Ativo"
            :readonly="readOnly"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6" class="text-right">
          <v-btn to="/marca" color="error" class="mr-4" v-if="!readOnly">
            Voltar
          </v-btn>
          <v-btn to="/marca" color="success" class="mr-4" v-else>
            Voltar
          </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4" v-if="!readOnly">
            Salvar
          </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import TabNavegacaoProduto from "../../Tabs/TabCadastroProduto";
import { editarMarcaAsync } from "../../../services/marcaService";
import { mapState, mapActions } from "vuex";
import { getUserPermission } from "@/services/loginService";

export default {
  name: "editarMarca",
  data: () => ({
    overlay: false,
    valid: true,
    descricao: null,
    readOnly: false,
  }),
  computed: {
    ...mapState("marca", ["marca"]),
    ...mapState("produto", ["produtos"]),
  },
  methods: {
    ...mapActions("produto", ["atualizarProdutos"]),
    ...mapActions("marca", ["updateMarca"]),
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await editarMarcaAsync(
          this.marca.id,
          this.descricao,
          this.marca.ativo
        );
        if (!resposta || resposta.message || resposta.Message) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(resposta && (resposta.message || resposta.Message) ? resposta.message || resposta.Message : "", "Descupe, falha na operação!", "error");
        } else {
          this.updateMarca(resposta);
          this.overlay = false;
          this.$store.dispatch("ui/showSnackbar", {
            text: "Atualizado com sucesso!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push("/marca");
        }
      }
    },
    findProduto(marcaId) {
      return this.produtos.filter((p) => {
        return p.idMarca == marcaId && p.ativo === true;
      });
    },
    checkAssociacao: async function () {
      if (!this.marca.ativo) {
        if (!this.produtos || this.produtos.length == 0) {
          this.overlay = true;
          await this.atualizarProdutos();
          this.overlay = false;
        }
        var produtos = this.findProduto(this.marca.id);
        if (produtos != null && produtos.length > 0) {
          this.$alert(
            "O(s) produtos(s) '" +
              produtos.map((e) => e.descricao).join("', '") +
              "' estão ativos e associados a essa Marca.",
            "Ação não permitida!",
            "error"
          );
          this.marca.ativo = !this.marca.ativo;
        }
      }
    }
  },
  created: function () {
    this.readOnly = !getUserPermission(6);
    this.descricao = this.marca.descricao;
  },
  components: {
    TabNavegacaoProduto,
  },
};
</script>
